import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();


  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        {/* Logo */}
        <Link to="/" style={styles.logo}>
          <div style={styles.logoIcon}>TG</div>
          <div>
            <span style={styles.logoText}>Tura</span>
            <span style={styles.logoAccent}>Grammar</span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav style={styles.nav}>
          {!isAuthenticated && <Link to="/login?redirect=/editor" style={styles.navLink}>Editor</Link>}
          <Link to="/pricing" style={styles.navLink}>Pricing</Link>
          {isAuthenticated ? (
            <>
              {user?.role === 'admin' ? (
                <Link to="/admin" style={styles.btnPrimary}>Admin Panel</Link>
              ) : (
                <Link to="/editor" style={styles.btnPrimary}>Go to Editor</Link>
              )}
              <span style={styles.navUser}>Hi, {user?.name?.split(' ')[0]}</span>
              <button onClick={handleLogout} style={styles.btnOutline}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" style={styles.navLink}>Login</Link>
              <Link to="/register" style={styles.btnPrimary}>Register</Link>
            </>
          )}
        </nav>

        {/* Mobile Menu Toggle */}
        <button style={styles.menuBtn} onClick={() => setMenuOpen(!menuOpen)}>
          <span style={styles.menuIcon}>{menuOpen ? 'X' : 'Menu'}</span>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={styles.mobileMenu}>
          {!isAuthenticated && <Link to="/login?redirect=/editor" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Editor</Link>}
          <Link to="/pricing" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Pricing</Link>
          {isAuthenticated ? (
            <>
              {user?.role === 'admin' ? (
                <Link to="/admin" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Admin Panel</Link>
              ) : (
                <Link to="/editor" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Go to Editor</Link>
              )}
              <button onClick={() => { handleLogout(); setMenuOpen(false); }} style={styles.mobileLinkBtn}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Login</Link>
              <Link to="/register" style={styles.mobileLink} onClick={() => setMenuOpen(false)}>Register</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};

const styles = {
  header: { background: '#ffffff', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 1px 3px rgba(0,0,0,0.08)' },
  container: { maxWidth: '1200px', margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px' },
  logo: { display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' },
  logoIcon: { width: '36px', height: '36px', borderRadius: '8px', background: 'linear-gradient(135deg, #4f46e5, #7c3aed)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '14px' },
  logoText: { fontSize: '20px', fontWeight: '700', color: '#1f2937' },
  logoAccent: { fontSize: '20px', fontWeight: '700', color: '#4f46e5' },
  nav: { display: 'flex', alignItems: 'center', gap: '24px' },
  navLink: { textDecoration: 'none', color: '#4b5563', fontSize: '15px', fontWeight: '500', transition: 'color 0.2s' },
  navUser: { color: '#6b7280', fontSize: '14px' },
  btnPrimary: { background: 'linear-gradient(135deg, #4f46e5, #7c3aed)', color: '#fff', padding: '8px 18px', borderRadius: '8px', textDecoration: 'none', fontSize: '14px', fontWeight: '600', border: 'none', cursor: 'pointer' },
  btnOutline: { background: 'transparent', color: '#4f46e5', padding: '8px 18px', borderRadius: '8px', fontSize: '14px', fontWeight: '600', border: '1.5px solid #4f46e5', cursor: 'pointer' },
  menuBtn: { display: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' },
  menuIcon: { fontSize: '22px', color: '#374151' },
  mobileMenu: { background: '#fff', borderTop: '1px solid #e5e7eb', padding: '16px 24px', display: 'flex', flexDirection: 'column', gap: '12px' },
  mobileLink: { textDecoration: 'none', color: '#374151', fontSize: '16px', fontWeight: '500', padding: '8px 0' },
  mobileLinkBtn: { background: 'none', border: 'none', color: '#374151', fontSize: '16px', fontWeight: '500', cursor: 'pointer', textAlign: 'left', padding: '8px 0' },
};

export default Header;
